import React from "react";
import styled, { keyframes } from "styled-components";
import { Box } from "../../Box";
const progress = keyframes `
  0% {
    background-position: 100% 0%;
  }
  100% {
    background-position: 0% 0%;
  }
`;
const View = styled(Box) `
  flex: 1;
  background: ${({ theme: { colors: { tableColors }, }, }) => `linear-gradient(to right, ${tableColors.placehoderGradient1}, ${tableColors.placehoderGradient2}, ${tableColors.placehoderGradient1})`};
  background-size: 800% 200%;
  animation: ${progress} 3s ease infinite;
`;
export const Placeholder = (props) => (React.createElement(View, Object.assign({ margin: "21px", height: "6px", "data-testid": "Placeholder" }, props)));
